const isStartOfDocument = ({titleIndex, subtitleIndex, paragraphIndex}) => {
    return (titleIndex===0 && subtitleIndex===0 && paragraphIndex===0)
}

export default isStartOfDocument;